function calculateProgress(currentVal, targetVal) {
    let progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
    let progressNum = document.querySelectorAll('.cart-shipping__num');
    let progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
    let successMsg = document.querySelectorAll('.cart-shipping__success');

    let result = Math.round(100 * currentVal / targetVal);
    progressBar.forEach(function (el) {
        el.setAttribute('style', "width: ".concat(result, "%"));
    })

    let newProgressNum = (targetVal - currentVal) / 100;
    if (newProgressNum <= 0) {
        successMsg.forEach(function (el) {
            el.setAttribute('style', 'display: block;');
        });
        progressOuter.forEach(function (el) {
            el.setAttribute('style', 'display: none;');
        });
        progressNum.forEach(function (el) {
            el.textContent = newProgressNum;
        });
    } else {
        successMsg.forEach(function (el) {
            el.setAttribute('style', 'display: none;');
        });
        progressOuter.forEach(function (el) {
            el.setAttribute('style', 'display: block;');
        });
        progressNum.forEach(function (el) {
            el.textContent = newProgressNum;
        });
    }
};

fetch('/cart.js')
    .then(response => response.json())
    .then(data => { 
    return calculateProgress(
          data.total_price, parseInt("6500") 
        ); 
    }); 
